'use client'

import Link from 'next/link'
import React, { useEffect, useState } from 'react'

import { PageCategoryData } from '@/lib/api-connector-strapi-cms/api/page-category/pageCategoryApi.types'
import { getCategoryLink } from '@/lib/api-connector-strapi-cms/utils/getCategoryLink.utils'
import { Button } from '@/lib/ui-kit/components/ui/Button.component'
import { Icon } from '@/lib/ui-kit/components/ui/Icon.component'
import { IconType } from '@/lib/ui-kit/components/ui/Icon.types'
import {
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
} from '@/lib/ui-kit/components/ui/NavigationMenu.component'

type SubSectionHeaderBlogProps = {
  categoriesNavigation?: PageCategoryData[]
}

export const SubSectionHeaderBlog = ({
  categoriesNavigation,
}: SubSectionHeaderBlogProps) => {
  const [isHidden, setIsHidden] = useState(false)

  useEffect(() => {
    const submenuDiv = document.querySelector('.submenu-navigation')

    if (submenuDiv) {
      const hasChildren = submenuDiv.children.length > 0
      setIsHidden(hasChildren)

      const observer = new MutationObserver(() => {
        const hasChildren = submenuDiv.children.length > 0

        if (hasChildren) {
          setIsHidden(true)
        } else {
          setIsHidden(false)
        }
      })

      observer.observe(submenuDiv, { childList: true })

      return () => observer.disconnect()
    }
  }, [])

  return (
    <section
      className={`flex w-full max-w-[1440px] transition-opacity duration-100 ${
        isHidden ? 'hidden' : ''
      }`}
    >
      {categoriesNavigation ? (
        <NavigationMenuList>
          {categoriesNavigation.map(({ linkCategory, category }) => (
            <NavigationMenuItem
              key={linkCategory}
              className="flex h-full items-center"
            >
              <NavigationMenuLink
                className={`paragraph-s group mx-4 inline-flex h-10 w-max items-center justify-center rounded-none border-b-[1px] border-solid border-transparent px-0 py-2 font-medium transition-colors hover:border-gray-1000 focus:text-accent-foreground focus:outline-none disabled:pointer-events-none disabled:opacity-50 data-[active]:border-gray-1000 data-[state=open]:border-gray-1000`}
                asChild
              >
                <Link href={getCategoryLink(linkCategory)}>{category}</Link>
              </NavigationMenuLink>
            </NavigationMenuItem>
          ))}
          <NavigationMenuItem
            key="/press-coverage"
            className="flex h-full items-center"
          >
            <NavigationMenuLink
              className={`paragraph-s group mx-4 inline-flex h-10 w-max items-center justify-center rounded-none border-b-[1px] border-solid border-transparent px-0 py-2 font-medium transition-colors hover:border-gray-1000 focus:text-accent-foreground focus:outline-none disabled:pointer-events-none disabled:opacity-50 data-[active]:border-gray-1000 data-[state=open]:border-gray-1000`}
              asChild
            >
              <Link href={getCategoryLink('press-coverage')}>
                Press Coverage
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>
        </NavigationMenuList>
      ) : null}
      <Link href="/blog/search" className="z-30 ml-auto">
        <Button variant="secondary" className="shadow">
          Search
          <Icon className="ml-4" type={IconType.search} />
        </Button>
      </Link>
    </section>
  )
}
